import React,{ forwardRef, useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { BaseBlockProps, ChartDataItem } from '../types';
import { useUserStatistics } from '../../../hooks';
import { getSchemeOrDefault } from '../../../utils/chartConfig';
import {
    BlockWrapper,
    LoadingState,
} from '../base';
import { PieChart } from '../../../Components/Display';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface UserStatisticsBlockProps extends BaseBlockProps {}

export const UserStatisticsBlock = forwardRef<HTMLDivElement, UserStatisticsBlockProps>(
    ({ kedo, block, dashboard }, ref) => {
        const { data, loading } = useUserStatistics(kedo, block);

        const chartData = useMemo((): ChartDataItem[] => {
            if (!data) return [];

            return [
                {
                    id: 'offline',
                    label: kedo.t('Offline'),
                    value: data.offline,
                    color: 'hsl(20,100%,43%)',
                },
                {
                    id: 'online',
                    label: kedo.t('online'),
                    value: data.online,
                    color: 'hsl(102,100%,43%)',
                },
            ];
        }, [data, kedo]);

        const scheme = getSchemeOrDefault(block.settings?.scheme);

        return (
            <BlockWrapper ref={ref} dashboard={dashboard}>
                <Typography variant="h6" component="h3" gutterBottom>
                    {kedo.t('User statistics')}
                </Typography>
                <Box sx={{ height: 300, width: '100%' }}>
                    {loading ? (
                        <LoadingState />
                    ) : (
                        <PieChart
                            data={chartData}
                            colors={{ scheme }}
                            innerRadius={0.75}
                            enableArcLinkLabels={false}
                            legendPosition="bottom"
                            
                        />
                    )}
                </Box>
            </BlockWrapper>
        );
    }
);

UserStatisticsBlock.displayName = 'UserStatisticsBlock';
